import { AppState } from "../reducers";
import { LoggingState } from '../reducers/logging_reducer';

export const selectLoggingState = (state: AppState): LoggingState => state.logging;

export const getPendingLogMessages = (state: AppState) => selectLoggingState(state).messages;
